<template>
  <div>
    <div class="content">
      <div class="topCont">
        <div class="contentLeft">
          <div class="contBox">
            <div class="title">1.基本信息</div>
            <div class="text">负责人的联系人，联系方式等</div>
            <div class="box">
              <div class="name">公司:</div>
              <div class="txt">
                {{ comInfo.industry_cn }}·{{ comInfo.name }}
              </div>
            </div>
            <div class="box">
              <div class="name mr5">联系人:</div>
              <div class="inpBox">
                <input
                  type="text"
                  v-model="person"
                  placeholder="请输入联系人"
                />
              </div>
            </div>
            <div class="box">
              <div class="name mr5">联系方式:</div>
              <div class="inpBox">
                <input
                  type="text"
                  v-model="mobile"
                  placeholder="请输入联系方式"
                />
              </div>
            </div>
            <div class="box">
              <div class="name mr5">备注:</div>
              <div class="tareBox">
                <textarea v-model="content" placeholder="请输入备注"></textarea>
              </div>
            </div>
            <div class="zhutxt" v-if="info.introduction">注：{{ info.introduction }}</div>
          </div>
        </div>
        <div class="contentRit">
          <div class="addBtn dis-cent" @click="addClick">新增岗位</div>
          <div class="inpBox">
            <input
              type="text"
              placeholder="输入名称搜索"
              v-model="searChTxt"
              @keyup.enter="searchClick"
            />
          </div>
          <div class="title">3.岗位选择</div>
          <div class="text">选择在招聘会上招聘的工作</div>
          <div class="contList">
            <div
              class="cont"
              v-for="(item, index) in list"
              :class="item.select ? 'contOn' : ''"
              @click="listClick(index)"
            >
              <div class="kuangBox dis-cent">
                <div class="kuang dis-cent" :class="item.select ? 'on' : ''">
                  <div class="iconfont icon-right" v-if="item.select"></div>
                </div>
              </div>
              <div class="txtCont">
                <div class="name c-1">{{ item.jobs_name }}</div>
                <div class="txt">
                  {{
                    item.minwage == 0 && item.maxwage == 0
                      ? "面议"
                      : item.minwage + "-" + item.maxwage + "K"
                  }}
                </div>
              </div>
              <div class="zhuangtai">
                <div class="yuan"></div>
                <div class="name">
                  {{
                    item.audit == 3
                      ? "审核失败"
                      : item.display == 1
                      ? "开放中"
                      : "已关闭"
                  }}
                </div>
              </div>
              <div class="txt" @click.stop="bjClick(item.id, item.display)">
                编辑
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wzCont">
        <div class="contentLeft">
          <div class="contBox">
            <div class="title">2.位置选择</div>
            <div class="text">选择想要申请的摊位位置</div>
            <div class="text">1). 展会图</div>
            <div class="box">
              <div class="img" v-if="info.zresources" @click="imgShow = true">
                <img :src="$imgUrl + info.zresources[0].path_name" />
              </div>
            </div>
          </div>
        </div>
        <div class="contentRit">
          <div class="contBox">
            <div class="text">2). 位置选择</div>
            <div class="box" style="margin-bottom: 5px">
              <div class="xuanCont">
                <div
                  class="cont dis-cent"
                  :class="
                    item.issign == 0
                      ? 'shenghe'
                      : item.issign == 1
                      ? 'yixuan'
                      : item.select
                      ? 'xuanzhong'
                      : 'weixuan'
                  "
                  v-for="(item, index) in position.children"
                  @click="positionClick(item, index)"
                >
                  <div class="tCont">{{ item.name }}</div>
                  <div class="tcBox" v-if="item.issign == 1">
                    <div class="tcTxt">
                      <div>已被申请</div>
                    </div>
                  </div>
                  <div class="tcBox" v-if="item.issign == 0">
                    <div class="tcTxt">
                      <div>审核中</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="beizhu">
              备注：灰底表示已经被申请走,白底黑框为可申请
            </div>
            <div
              class="text"
              style="margin-top: 20px; margin-bottom: 0px"
              v-if="rack > 0 && proxy > 0"
            >
              3). 会员功能
            </div>
            <div class="zhCont" v-if="rack > 0">
              <div class="kuang" :class="zjShow ? 'kon' : ''" @click="zjClick">
                <div class="iconfont icon-right" v-if="zjShow"></div>
              </div>
              <div class="name" :class="zjShow ? 'ton' : ''">是否定制展架</div>
            </div>
            <div class="zhCont" v-if="proxy > 0">
              <div class="kuang" :class="xzShow ? 'kon' : ''" @click="xzClick">
                <div class="iconfont icon-right" v-if="xzShow"></div>
              </div>
              <div class="name" :class="xzShow ? 'ton' : ''">是否需要代招</div>
            </div>
          </div>
        </div>
      </div>
      <div class="fbBox">
        <div class="btn dis-cent" @click="saveClick">提交</div>
      </div>
    </div>
    <ImgBig v-if="imgShow" @del="imgDelJs" :list="imgList" :index="0" />
    <a-modal
      v-model="visible"
      title="提示"
      @ok="handleOk"
      cancelText="取消"
      okText="确定"
    >
      <p>您的免费次数已经用完，是否前往支付后申请此招聘会。</p>
    </a-modal>
  </div>
</template>

<script>
import ImgBig from "../component/imgBig.vue";
import XuanzeLd from "../component/xuanzeLd.vue";
import {
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  Popconfirm,
  Modal,
} from "ant-design-vue";
export default {
  components: {
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    "a-popconfirm": Popconfirm,
    "a-modal": Modal,
    XuanzeLd,
    ImgBig,
  },
  name: "",
  data() {
    return {
      visible: false,
      imgList: [],
      imgShow: false,
      list: [],
      person: "",
      mobile: "",
      info: {
        zresources: [{}],
      },
      position: {
        children: [],
      },
      content: "",
      order_id: "",
      zjShow: false,
      xzShow: false,
      proxy: 0,
      rack: 0,
      searChTxt: "",
      comInfo: {},
      page: {
        pageNo: -1,
      },
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.get();
    this.listGet();
    this.recruit_sign_before();
    this.recruit_get();
  },
  methods: {
    searchClick() {
      this.page.jobs_name = this.searChTxt;
      this.totalCount = 0;
      this.listGet();
    },
    zjClick() {
      this.zjShow = !this.zjShow;
    },
    xzClick() {
      this.xzShow = !this.xzShow;
    },
    handleOk() {
      this.visible = false;
      this.$router.push({
        path: "/pay",
        query: {
          id: this.order_id,
        },
      });
    },
    recruit_sign_before() {
      this.$get("/nozzle/web/recruit_sign_before", {
        id: this.id,
      }).then((res) => {
        this.proxy = res.proxy;
        this.rack = res.rack;
      });
    },
    recruit_get() {
      this.$get("/nozzle/web/recruit_get", {
        id: this.id,
      }).then((res) => {
        this.info = res.data;
        this.imgList = res.data.zresources ? res.data.zresources : [];
        if (res.position.length != 0) {
          for (let i = 0; i < res.position[0].children.length; i++) {
            const e = res.position[0].children[i];
            e.select = false;
          }
          this.position = res.position[0];
        }
      });
    },
    listGet() {
      this.$get("/nozzle/web/company_job", this.page).then((res) => {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.select = false;
          }
          this.list = res.data;
        }
      });
    },
    bjClick(id, dis) {
      this.$router.push({
        path: "/gongsi/addZhiwei",
        query: {
          type: 0,
          id,
          kaifang: dis,
        },
      });
    },
    saveClick() {
      let data = {};
      data.person = this.person;
      data.mobile = this.mobile;
      data.content = this.content;
      let sel = [];
      for (let i = 0; i < this.list.length; i++) {
        const e = this.list[i];
        if (e.select) {
          sel.push(e.id);
        }
      }
      data.jobs_length = sel.length;
      data.jobs_id = sel.join(",");
      let wzId = "";
      for (let i = 0; i < this.position.children.length; i++) {
        const e = this.position.children[i];
        if (e.select) {
          wzId = e.id;
        }
      }
      data.position_id = Number(wzId);
      data.way = 1;
      data.recruit_id = Number(this.id);
      data.is_rack = !this.zjShow ? 0 : 1;
      data.is_proxy = !this.xzShow ? 0 : 1;
      if (!data.person) {
        this.$message.error("请输入联系人");
        return;
      }
      if (!data.mobile) {
        this.$message.error("请输入联系方式");
        return;
      }
      if (!data.jobs_length) {
        this.$message.error("请选择岗位");
        return;
      }
      if (!data.position_id) {
        this.$message.error("请选择位置");
        return;
      }
      console.log(data);
      data = JSON.stringify(data);
      this.$post("/nozzle/web/recruit_sign_save", {
        data: data,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("提交成功");
          if (res.data.data.order_id) {
            this.order_id = res.data.data.order_id;
            this.visible = true;
          } else {
            setTimeout(() => {
              this.$router.go(-1);
            }, 500);
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    get() {
      this.$get("/nozzle/web/company_info").then((res) => {
        console.log(res);
        this.comInfo = res.data;
        this.person = res.data.person;
        this.mobile = res.data.mobile;
      });
    },
    addClick() {
      this.$router.push({
        path: "/gongsi/addZhiwei",
        query: {
          type: 0,
          kaifang: 1,
        },
      });
    },
    positionClick(item, i) {
      console.log(item);
      // if (item.issign==1) {
      //   this.$message.error("此位置已被预定");
      //   return
      // }
      if (!this.position.children[i].select) {
        for (let i = 0; i < this.position.children.length; i++) {
          const e = this.position.children[i];
          e.select = false;
        }
      }
      this.position.children[i].select = !this.position.children[i].select;
    },
    listClick(i) {
      this.list[i].select = !this.list[i].select;
    },
    imgDelJs() {
      this.imgShow = false;
    },
    hyClick(e) {
      console.log(e);
    },
    ldShowJs(e) {
      this.ldData = e.data;
      this.ldShow = false;
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  margin: auto;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 10px;
  width: 1280px;
  padding: 20px 40px;

  .topCont {
    display: flex;
    max-height: 500px;

    .text {
      color: #666;
      margin-bottom: 30px;
    }

    .contentLeft {
      width: 550px;

      .zhutxt {
        text-align: justify;
        text-indent: 2em;
        color: #666;
      }

      .title {
        font-weight: 600;
        font-size: 20px;
        margin-bottom: 5px;
      }

      .box {
        display: flex;
        margin-bottom: 15px;

        .name {
          color: #666;
          width: 90px;
          text-align: right;
        }

        .mr5 {
          margin-top: 5px;
        }

        .txt {
          width: calc(100% - 90px);
          padding-left: 10px;
          box-sizing: border-box;
          font-size: 14px;
        }

        .inpBox {
          width: calc(100% - 90px);
          padding: 0 10px;
          height: 35px;
          margin-left: 10px;
          border-radius: 5px;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #9c9c9c;
          overflow: hidden;
          cursor: pointer;

          .seleTxt {
            width: calc(100% - 35px);
          }

          .enter {
            width: 35px;
            text-align: right;
            font-size: 14px;
          }

          input {
            width: 100%;
            height: 100%;
            color: #000;
          }
        }

        .tareBox {
          width: calc(100% - 90px);
          height: 160px;
          margin-left: 10px;
          border-radius: 5px;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          display: flex;
          align-items: center;
          justify-content: space-between;
          overflow: hidden;
          cursor: pointer;

          textarea {
            width: 100%;
            height: 100%;
            border: none;
            padding: 10px;
          }
        }
      }

      .img {
        width: 250px;
        height: 150px;
        margin-left: 10px;
        cursor: pointer;

        img {
          object-fit: cover;
        }
      }

      .xuanCont {
        width: calc(100% - 90px);
        padding-left: 10px;
        display: flex;
        flex-wrap: wrap;

        .cont {
          width: calc(25% - 7.5px);
          margin-right: 10px;
          height: 35px;
          border-radius: 5px;
          box-sizing: border-box;
          margin-bottom: 10px;
          float: left;
          cursor: pointer;
          position: relative;

          .tcBox {
            position: absolute;
            background-color: #fff;
            top: 35px;
            left: 0;
            // padding: 15px;
            width: 200px;
            border-radius: 5px;
            padding: 10px 15px;
            border: 1px solid #ebebeb;
            z-index: 9;
            display: none;
          }
        }

        .cont:hover {
          .tcBox {
            display: block;
          }
        }

        .weixuan {
          border: 1px solid #ebebeb;
        }

        .yixuan {
          background-color: #c9c9c9;
        }

        .shenghe {
          background-color: #f14805;
        }

        .xuanzhong {
          border: 1px solid #198eee;
        }

        .cont:nth-child(4n) {
          margin-right: 0;
        }
      }

      .beizhu {
        margin-top: 0;
        padding-left: 100px;
        font-size: 12px;
        color: #9c9c9c;
      }
    }

    .contentRit {
      width: calc(100% - 550px);
      box-sizing: border-box;
      padding-left: 60px;
      position: relative;

      .addBtn {
        position: absolute;
        top: 10px;
        right: 0;
        height: 40px;
        width: 90px;
        background-color: #1a78ec;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
      }

      .inpBox {
        position: absolute;
        top: 10px;
        right: 100px;
        border: 1px solid #ebebeb;
        width: 200px;
        height: 40px;
        border-radius: 5px;
        box-sizing: border-box;
        input {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding-left: 10px;
        }
      }

      .title {
        font-weight: 600;
        font-size: 20px;
        margin-bottom: 5px;
      }

      .text {
        color: #666;
        margin-bottom: 30px;
      }

      .contList {
        height: calc(100% - 85px);
        overflow: auto;

        .cont {
          border: 1px solid #ebebeb;
          border-radius: 10px;
          padding: 10px 0;
          display: flex;
          margin-bottom: 10px;
          cursor: pointer;
          align-items: center;

          .kuangBox {
            width: 60px;

            .kuang {
              width: 18px;
              height: 18px;
              border-radius: 5px;
              border: 1px solid #c9c9c9;
            }

            .on {
              border: 1px solid #147ee0;
              background-color: #147ee0;
              color: #fff;
            }
          }

          .txtCont {
            width: calc(100% - 240px);
            display: flex;
            align-items: center;

            .name {
              font-size: 16px;
              width: calc(100% - 60px);
            }

            .txt {
              width: 60px;
              text-align: center;
              font-weight: 600;
              font-size: 18px;
              color: #f80d0d;
            }

            .textBox {
              display: flex;
              align-items: center;
              font-size: 13px;
              color: #9c9c9c;
              margin-top: 10px;

              .shu {
                width: 1px;
                height: 12px;
                background-color: #e0e0e0;
                margin: 0 10px;
              }
            }
          }

          .zhuangtai {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 120px;

            .yuan {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: #1a78ec;
              margin-right: 5px;
            }
          }
        }

        .contOn {
          border: 1px solid #147ee0;
        }

        .cont:hover {
          border: 1px solid #147ee0;
        }
      }
    }
  }

  .wzCont {
    display: flex;
    padding-top: 40px;

    .contentLeft {
      width: 550px;

      .title {
        font-weight: 600;
        font-size: 20px;
        margin-bottom: 5px;
      }

      .text {
        color: #666;
        margin-bottom: 30px;
      }

      .boxs {
        display: flex;
      }

      .box {
        margin-bottom: 15px;

        .img {
          width: 100%;
          height: auto;
          margin-left: 10px;
          cursor: pointer;

          img {
            object-fit: cover;
          }
        }
      }
    }

    .contentRit {
      width: calc(100% - 550px);
      box-sizing: border-box;
      padding-left: 60px;
      position: relative;

      .contBox {
        padding-top: 80px;
        .text {
          color: #666;
          margin-bottom: 30px;
        }
      }

      .xuanCont {
        width: calc(100% - 0);
        padding-left: 10px;
        display: flex;
        flex-wrap: wrap;

        .cont {
          width: calc(25% - 7.5px);
          margin-right: 10px;
          height: 40px;
          border-radius: 5px;
          box-sizing: border-box;
          margin-bottom: 10px;
          float: left;
          cursor: pointer;
          position: relative;

          .tcBox {
            position: absolute;
            background-color: #fff;
            top: 40px;
            left: 0;
            // padding: 15px;
            width: 200px;
            border-radius: 5px;
            padding: 10px 15px;
            border: 1px solid #ebebeb;
            z-index: 9;
            display: none;
          }
        }

        .cont:hover {
          .tcBox {
            display: block;
          }
        }

        .weixuan {
          border: 1px solid #ebebeb;
        }

        .yixuan {
          background-color: #c9c9c9;
        }

        .shenghe {
          background-color: #f14805;
        }

        .xuanzhong {
          border: 1px solid #198eee;
        }

        .cont:nth-child(4n) {
          margin-right: 0;
        }
      }

      .beizhu {
        margin-top: 0;
        padding-left: 100px;
        font-size: 12px;
        color: #9c9c9c;
      }
    }
  }

  .fbBox {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .btn {
      width: 90px;
      height: 40px;
      border-radius: 5px;
      background-color: #147ee0;
      color: #fff;
      cursor: pointer;
    }
  }
}

.zhCont {
  display: flex;
  margin-top: 12px;
  align-items: center;
  color: #888;

  .kuang {
    width: 20px;
    height: 20px;
    border-radius: 5px;
    border: 1px solid #c9c9c9;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
    cursor: pointer;
  }

  .kon {
    border: 1px solid #147ee0;
    background-color: #147ee0;
    color: #fff;
  }

  .ton {
    color: #147ee0;
  }
}
</style>
